import './index.scss'


function getSliderTransition() {
    return window.innerWidth > 992 ? 'fade' : 'slide';
}

const instances = new Map();

function beforeSplideMount(splide) {
    const carouselElement = splide.root;

    //Init Synced Carousels
    if (carouselElement.dataset?.sync) {
        const syncElement = document.querySelector(carouselElement.dataset.sync);
        const syncCarousel = new Splide(syncElement);
        splide.sync(syncCarousel);
        syncCarousel.mount();
    }

    splide.on("mounted move", () => {
        const total = splide.length;
        const current = splide.index + 1;
        const stepCounter = splide.root.querySelector(".splide__steps");
        if (stepCounter) {
        stepCounter.textContent = `${current} of ${total}`;
        }
    });
}

function detroyRebuildSplide(oldCarousel, options) {
    // Destroy existing instance (full cleanup) before re-mount
    if (instances.has(oldCarousel)) {
        instances.get(oldCarousel).destroy(true);
    }

    const newCarousel = new Splide(oldCarousel, options);
    
    beforeSplideMount(newCarousel);
    newCarousel.mount();

    instances.set(oldCarousel, newCarousel);
    return newCarousel;
}

function initTestimonialCarousels() {
    const carousels = document.querySelectorAll('.carousel--testimonial');
    const $args = {
        perPage: 1,
        arrows: true,
        pagination: false,
        type: getSliderTransition(),
        autoWidth: true,
        breakpoints: {
            992: {
                gap: 20,
                arrows: false,
            },
        }
    };

    carousels.forEach(carousel => {
        detroyRebuildSplide(carousel, $args);
    });
}

initTestimonialCarousels();

// Rebuild on resize (debounced)
let timeout;
window.addEventListener('resize', () => {
    clearTimeout(timeout);
    timeout = setTimeout(initTestimonialCarousels, 150);
});


function initOtherCarousels() {
    const carousels = document.querySelectorAll('.carousel--posts, .carousel--case-results');

    function getCarouselOptions(carousel) {
        if (carousel.classList.contains('carousel--posts')) {
            return {
                destroy: true,
                autoWidth: true,
                arrows: false,
                pagination: false,
                breakpoints: {
                    992: {
                        destroy: false,
                        gap: 0,
                        type: "slide",
                        arrows: false,
                    },
                },
            };
        } else if (carousel.classList.contains('carousel--case-results')) {
            return {
                destroy: true,
                autoWidth: true,
                arrows: false,
                pagination: false,
                breakpoints: {
                    992: {
                        destroy: false,
                        gap: 0,
                        type: "slide",
                        arrows: false,
                    },
                },
            };
        }
    }

    for (let i = 0; i < carousels.length; i++ ) {
        let $options = getCarouselOptions(carousels[i]); 
        new Splide(carousels[i], $options).mount();
    }
}
document.addEventListener('DOMContentLoaded', initOtherCarousels);
